// extracted by mini-css-extract-plugin
module.exports = {"root":"Auth_root__3ElgF","login":"Auth_login__3aGwJ","error":"Auth_error__2r2Sh","info":"Auth_info__u6VPI","qan":"Auth_qan__39e-j"};